<template>
  <div class="login-wrap">
    <div class="row">
      <div class="col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t">
        <img src="../../assets/images/logo-login.png" alt="">
        <h2 class="push-50-t">{{ labelFieldTitle[actualLanguage] }}</h2>
        <div v-if="errorMsg" class="alert push-30-t alert-danger alert-dismissable">
          <p>{{errorMsg}}</p>
        </div>

        <p class="push-30-t">{{ labelFieldMessage[actualLanguage] }}</p>

        <form class="simple_form form-horizontal push-50-t">
          <div class="form-inputs">

            <div class="form-group">
              <div class="col-xs-12">
                <div class="form-material form-material-primary">
                  <input class="form-control string text optional form-control" v-model="userInfos.email" autofocus="autofocus" type="text" value="" id="user_email">
                  <label for="user_email">{{ labelFieldEmail[actualLanguage] }}</label>
                </div>
              </div>
            </div>


            <div class="form-group">
              <div class="col-xs-12">
                <div class="form-material form-material-primary">
                  <input class="form-control string text optional form-control" v-model="userInfos.verifyCode" autofocus="autofocus" type="text" value="" id="user_verifyCode">
                  <label for="user_verifyCode">{{ labelFieldConfirmationCode[actualLanguage] }}</label>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <div class="col-xs-12 text-center push-30-t">
                <button v-if="!isVerifying" type="button" @click="submitVerification" style="min-width: 250px" class="btn btn-connexion btn-success">{{ labelFieldButtonVerify[actualLanguage] }}</button>
                <spinner v-else></spinner>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center" style="margin-top: 100px">
        <p>{{ labelFieldAlready[actualLanguage] }}
          <router-link style="margin-left: 5px" class="btn btn-default btn-rounded"  :to="{name: 'login'}">
            {{ labelFieldButtonLogIn[actualLanguage] }}
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import Spinner from '../../components/Spinner'


export default {
  components: {
    Spinner
  },
  name: 'verify',
  data () {
    return {
      userInfos: {
        verifyCode: '',
        email: '',
        name:'',
        language:'',
      },
      isVerifying: false,
      errorMsg: '',

      actualLanguage : "FR",
      labelFieldTitle: {FR: 'Vérification', EN: 'Verification'},
      labelFieldMessage: {FR: "Votre compte à été créé mais est inactif. Pour l'activer, veuillez saisir le code que nous vous avons envoyé par courriel dans le champ suivant:", EN: 'To confirm your account, verify your email and copy the confirmation code in the corresponding field and press "Verify"'},
      labelFieldEmail: {FR: 'Courriel', EN: 'Email'},
      labelFieldConfirmationCode: {FR: 'Code de vérification', EN: 'Confirmation code'},
      labelFieldButtonVerify: {FR: 'Vérifier', EN: 'Verify'},
      labelFieldAlready: {FR: "Vous avez déjà un compte ?", EN: 'You already have an account ?'},
      labelFieldButtonLogIn: {FR: "Se connecter", EN: 'Log in'},
      firstConnectMessage: {FR: 'Vous pouvez maintenant vous connecter.', EN: 'You can login now.'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['userEmail']),
    ...mapState('sessionStore', ['userName']),
    ...mapState('sessionStore', ['userLastName']),

  },
  mounted(){
    this.userInfos.email = this.userEmail
    this.userInfos.name = this.userName
    this.userInfos.lastName = this.userLastName

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.userInfos.language = this.actualLanguage

  },
  methods: {
    submitVerification() {
      this.isVerifying = true
      this.$store.dispatch('sessionStore/verify', this.userInfos)
      .then((user) => {
        this.isVerifying = false
        //this.$router.push({name: 'login', params: { notif: 'Vous pouvez maintenant vous connecter.' }})
        this.$router.push({name: 'login', params: { notif: this.firstConnectMessage[this.actualLanguage] }})
      })
      .catch((e) => {
        this.errorMsg = e.message
        this.isVerifying = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Verify.vue?0d67763a